import { fetcher } from '@commenda/utils';
import { TCreateTPAlertBody, TCreateTPAlertResponse } from './types';

export async function createTPAlert(
  body: TCreateTPAlertBody
): Promise<TCreateTPAlertResponse> {
  const response = await fetcher('tp-alert', {
    method: 'POST',
    body,
  });
  if (!response.ok) throw new Error('Failed to create alert');
  return (await response.json()) as TCreateTPAlertResponse;
}
